@for (item of contentArr; track item) {
  <div class="footer-pages-content">
    <h4>{{item.title}}</h4>
    <div [innerHTML]="item.paragraph"></div>
  </div>
}
